import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DegreeListComponent } from './degree-list/degree-list.component';
import { DegreeCreateComponent } from './degree-create/degree-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: DegreeListComponent,
        data: {
          title: "Degree List",
          breadcrumb: "Degree List"
        }
      },
      {
        path: 'create',
        component: DegreeCreateComponent,
        data: {
          title: "Create Degree",
          breadcrumb: "Create Degree"
        }
      },
      {
        path: 'edit/:id',
        component: DegreeCreateComponent,
        data: {
          title: "Edit Degree",
          breadcrumb: "Edit Degree"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class DegreeRoutingModule { }
